import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { CompanyService } from "src/core/services/company.service";
import { IndividualService } from "src/core/services/individual.service";
import { LocalStorageService } from "src/core/services/local-storage.service";
import { SharedService } from "src/core/services/shared.service";
import { Company, CompanyType } from "src/interfaces/company";

@Injectable({
    providedIn: 'root'
})
export class CompanyResolver  {

    constructor(
        private _companyService: CompanyService,
        private _sharedService: SharedService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{
       company: Company | null,
       companyTypes: CompanyType[], 
    }> {

        let company: Company | null = null;

        company  = await this
            ._companyService
            .getCompany(
                parseInt(route.params['id'])
            );
        const data: any = await this._sharedService.getFormData(['company_type']);
    
        const companyTypes: CompanyType[] = data ?  data.company_type : [];
        
        return {
            companyTypes,
            company
        }
        
    }
}

@Injectable({
    providedIn: 'root'
})
export class CompanyListResolver  {
    limit: number = 10;
    page: number = 1;
    constructor(
        private _companyService: CompanyService,
        private _localStorageService: LocalStorageService,
        private _sharedService: SharedService
    ) {
        const limit = this._localStorageService.get('COMPANIES', 'LIMIT');
        if (limit) {
            this.limit = parseInt(limit);
        }
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<
    {
        companies: Company[],
        pageNumber: number,
        companyTypes: CompanyType[],
    }
    > {

        const page = this._localStorageService.get('COMPANIES', 'PAGE');
        if (page) {
            this.page = parseInt(page);
        } else {
            this.page = 1;
        }
        
        const companies: Company[] = await  this
            ._companyService
            .getCompanies(this.page, this.limit);
        const data: any = await this._sharedService.getFormData(['company_type']);
        const companyTypes: CompanyType[] = data ? data.company_type : [];
        return {
            companies,
            pageNumber: this.page,
            companyTypes
        }
    }
}